import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({
                providedIn: 'root'
            })
export class MetaService {

    constructor(private meta: Meta) {}

    updateMetaTag(name: string, content: string) {
        this.meta.updateTag({ name: name, content: content });
    }

    // Add a new tag
    addMetaTag(tag: {name: string, content: string}) {
        this.meta.addTag(tag);
    }
}
